import { DocumentIssueComponent } from './document-issue/document-issue.component';
export var documentRoutes = [
    {
        path: 'document',
        data: {
            'expectedRoles': ['Accountant', 'Operation', 'Accountant Admin']
        },
        children: [
            {
                path: 'issue',
                component: DocumentIssueComponent
            }
        ],
    },
];
var DocumentRoutingModule = (function () {
    function DocumentRoutingModule() {
    }
    return DocumentRoutingModule;
}());
export { DocumentRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-routing.module.ts.pre-build-optimizer.js